import { useEffect } from 'react';
import { useAppStore } from '@/store/appStore';

/**
* Hook per rilevare se l'app è in modalità mobile (viewport <= 1024px).
* Sincronizza automaticamente lo stato mobile nello store quando cambia il breakpoint.
* 
* @returns true se la viewport è <= 1024px, false altrimenti
*/
export function useMobile() {
  const setIsMobile = useAppStore((state) => state.setIsMobile);
  const isMobile = useAppStore((state) => state.isMobile);

  // Sync mobile breakpoint to drive sidebar behavior
  useEffect(() => {
  if (typeof window === 'undefined' || !window.matchMedia) return;
  const mediaQuery = window.matchMedia('(max-width: 1024px)');
  const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
  };

  // Initialize on mount
  setIsMobile(mediaQuery.matches);
  mediaQuery.addEventListener('change', handleChange);
  return () => mediaQuery.removeEventListener('change', handleChange);
  }, [setIsMobile]);

  return isMobile;
}

